angular.module('dnecom')
    .service('ZonesUtils', function () {
        this.getCostTypeName = function(zone) {
            var names = {
                1: 'Flat fee',
                2: '% of total costs of the order',
                3: 'Custom based on the amount of order',
                4: 'Custom based on the amount per product'
            };

            return names[zone.shippingCostType] || '';
        };

        this.getCostInfo = function(zone) {
            if (_.has(zone, ['shippingCost', 'val'])) {
                if (zone.shippingCostType === 1) {
                    return '$' + zone.shippingCost.val;
                }
                if (zone.shippingCostType === 2) {
                    return zone.shippingCost.val + '%';
                }
            }

            if (_.isArray(zone.shippingCost)) {
                if (zone.shippingCostType === 1) {
                    if (_.has(zone.shippingCost[0], ['service'])) {
                        const prices = zone.shippingCost.map(e => e.price);
                        const minPrice = _.min(prices);
                        const maxPrice = _.max(prices);
                        const displayPrice = minPrice === maxPrice ? minPrice : `${minPrice} - ${maxPrice}`;
                        const sign = zone.shippingCostType === 1 ? '$' : '%';

                        return sign + displayPrice;
                    } else {
                        return zone.shippingCost[0] ? ('$' + zone.shippingCost[0]) : '$0';
                    }
                }

                if (zone.shippingCostType === 2) {
                    const prices = zone.shippingCost[0];

                    return prices + '%';
                }

                if (zone.shippingCostType === 3 || zone.shippingCostType === 4) {
                    if (!zone.shippingCost.length) {
                        return 'ranges not defined';
                    }
                    var range = zone.shippingCost[0];
                    if (_.has(range, ['from']) && _.has(range, ['to']) && _.has(range, ['price'])) {
                        return range.from + '-' + range.to + ': $' + range.price + '...';
                    }

                    return range.pricing[0].from + '-' + range.pricing[0].to + ': $' + range.pricing[0].price + '...';
                }
            }

            return zone.shippingCost;
        };

        this.isServicesAvailable = function (zone) {
            return _.isArray(zone.shippingCost) && zone.shippingCostType === 1 && _.isObject(zone.shippingCost[0])
        };

        this.zoneRateCostHtml = function (zone) {
            if (!this.isServicesAvailable(zone)) {
                return '';
            }
            let html = '';
            zone.shippingCost.forEach(function (service) {
                html += `<div class="rate-row row">
                       <div class="col-sm-4 rate-row-name">${service.service}</div>
                       <div class="col-sm-4 days-range">${service.minDays}-${service.maxDays} days</div>
                       <div class="col-sm-4 "><i class="fa fa-money" aria-hidden="true"></i> ${service.price.toFixed(2)}</div>
                    </div>`
            })

            return html;
        };
        
        return this;
    });
